import React from "react";
import axios from "axios";
import { Table, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import GLOBALVAR from "../constants";
import { format } from 'date-fns';
import LoadingSpinner from "../components/misc/LoadingSpinner";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import './css/ReportsStyles.scss'; 
import ToPeso from "../components/misc/ToPeso";
import logo from "../logo.png";
import calculateDueDates from "../components/misc/calculateDueDates";
import calculatePayments from "../components/misc/calculatePayments";

function ReportLoanListingByLoanStatus() {
    const [paymentHeaders, setPaymentHeaders] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [endDate, setEndDate] = useState('');
    const [loanCurrent, setLoanCurrent] = useState(null);
    const [loanPastdue, setLoanPastdue] = useState(null);
    const [loanCurrentTotals, setLoanCurrentTotals] = useState(null);
    const [loanPastdueTotals, setLoanPastdueTotals] = useState(null);

    const fetchLoans = async (endDate) => {
        setShowSpinner(true);

        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/fetch/all/loanstatus`, {
                params: {
                    endDate: endDate || undefined
                }
            });

            const countDaysBetweenDates = (startDate, endDate) => {
                // Parse the dates to ensure they are valid Date objects
                const start = new Date(startDate);
                const end = new Date(endDate);
                
                // Calculate the difference in milliseconds
                const diffInMs = end - start;
                
                // Convert milliseconds to days
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
                
                return Math.ceil(diffInDays); // Use Math.ceil to round up to the nearest whole number of days
            };

            const loansDataCurrent = response.data.current.loans.reduce((acc, item) => {
                const fullName = `${item.applicant.lastName}, ${item.applicant.firstName} ${item.applicant.middleName}`;
                const fullNameWithLink = (
                    <a href={`/applicant/${item.applicant.id}`}>
                        {fullName}
                    </a>
                );

                const loansnum = item.id.toString().padStart(6, '0');
                const loansNumWithLink = (
                    <a href={`/loans/${item.id}`}>
                        {loansnum}
                    </a>
                );

                const dates = calculateDueDates(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate);
                const paymentsArr = calculatePayments(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate, item.payments);
                const textdates = `${format(item.dateGranted, 'MM/dd/yyyy')} - ${dates[dates.length - 1].date}`;
                const termDays = countDaysBetweenDates(item.dateGranted, dates[dates.length-1].date);

                const loanDetails = {
                    items: [
                        { key: 'fullName', value: fullNameWithLink },
                        { key: 'loanProcessingID', value: loansNumWithLink },
                        { key: 'dateGrantedDue', value: textdates },
                        { key: 'amountGranted', value: <ToPeso amount={item.amountGranted} /> },
                        { key: 'interestAmount', value: <ToPeso amount={((item.amountGranted * (item.interestRate/100)) * item.loanTerm)} /> },
                        { key: 'totalBalance', value: <ToPeso amount={paymentsArr.remainingBalance} /> },
                        { key: 'interestRate', value: `${item.interestRate}%` },
                        { key: 'termDays', value: termDays },
                        { key: 'loanLedger', value: item.loanLedger },
                        { key: 'loanProduct', value: item.loanProduct },
                        { key: 'accountOfficer', value: item.accountOfficer },
                        { key: 'loanType', value: item.loanType },
                    ]
                };

                acc[item.id] = loanDetails;

                return acc;
            }, {});

            setLoanCurrent(loansDataCurrent);
            setLoanCurrentTotals(response.data.current.totals);

            const loansDataPastdue = response.data.pastDue.loans.reduce((acc, item) => {
                const fullName = `${item.applicant.lastName}, ${item.applicant.firstName} ${item.applicant.middleName}`;
                const fullNameWithLink = (
                    <a href={`/applicant/${item.applicant.id}`}>
                        {fullName}
                    </a>
                );

                const loansnum = item.id.toString().padStart(6, '0');
                const loansNumWithLink = (
                    <a href={`/loans/${item.id}`}>
                        {loansnum}
                    </a>
                );

                const dates = calculateDueDates(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate);
                const paymentsArr = calculatePayments(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate, item.payments);
                const textdates = `${format(item.dateGranted, 'MM/dd/yyyy')} - ${dates[dates.length - 1].date}`;
                const termDays = countDaysBetweenDates(item.dateGranted, dates[dates.length-1].date);

                const loanDetails = {
                    items: [
                        { key: 'fullName', value: fullNameWithLink },
                        { key: 'loanProcessingID', value: loansNumWithLink },
                        { key: 'dateGrantedDue', value: textdates },
                        { key: 'amountGranted', value: <ToPeso amount={item.amountGranted} /> },
                        { key: 'interestAmount', value: <ToPeso amount={((item.amountGranted * (item.interestRate/100)) * item.loanTerm)} /> },
                        { key: 'totalBalance', value: <ToPeso amount={paymentsArr.remainingBalance} /> },
                        { key: 'interestRate', value: `${item.interestRate}%` },
                        { key: 'termDays', value: termDays },
                        { key: 'loanLedger', value: item.loanLedger },
                        { key: 'loanProduct', value: item.loanProduct },
                        { key: 'accountOfficer', value: item.accountOfficer },
                        { key: 'loanType', value: item.loanType },
                    ]
                };

                acc[item.id] = loanDetails;

                return acc;
            }, {});

            setLoanPastdue(loansDataPastdue);
            setLoanPastdueTotals(response.data.pastDue.totals);


            const paymentHeaders = [
                { value: "Borrower's Name" },
                { value: "Loan No." },
                { value: "Date Granted - Due Date" },
                { value: "Principal" },
                { value: "Interest" },
                { value: "Balance" },
                { value: "Int Rate" },
                { value: "Term" },
                { value: "Loan Ledger" },
                { value: "Loan Product" },
                { value: "Account Officer" },
                { value: "Loan Type" }
            ];

            setPaymentHeaders(paymentHeaders);
            setShowSpinner(false);
        } catch (error) {
            console.error('Error fetching payments:', error);
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        fetchLoans(endDate);
    }, [endDate]);

    const handleGeneratePDF = async () => {
        setShowSpinner(true);
        try {
            const doc = new jsPDF('landscape');
    
            const centerText = (text, y, fontWeight = 'normal') => {
                doc.setFont(undefined, fontWeight);
                const pageWidth = doc.internal.pageSize.getWidth();
                const textWidth = doc.getTextDimensions(text).w;
                const textX = (pageWidth - textWidth) / 2;
                doc.text(text, textX, y);
            };
    
            const formatDate = (date) => {
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${month}/${day}/${year}`;
            };
    
            const logoImg = await fetch(logo);
            const logoBlob = await logoImg.blob();
            const logoURL = URL.createObjectURL(logoBlob);
            doc.addImage(logoURL, 'PNG', 10, 3, 70, 14.35);
    
            doc.setFontSize(14);
            centerText("Loan Listing By Loan Status", 10, 'bold');
    
            if (endDate) {
                doc.setFontSize(12);
                centerText(`As of ${formatDate(endDate)}`, 19);
            }
    
            const tableColumn = paymentHeaders.map(header => header.value);
    
            let currentY = 30; // Start position for the first table
    
            // Fetch the loan records
            const loansResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/fetch/all/loanstatus`, {
                params: {
                    endDate: endDate || undefined
                }
            });

            const countDaysBetweenDates = (startDate, endDate) => {
                // Parse the dates to ensure they are valid Date objects
                const start = new Date(startDate);
                const end = new Date(endDate);
                
                // Calculate the difference in milliseconds
                const diffInMs = end - start;
                
                // Convert milliseconds to days
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
                
                return Math.ceil(diffInDays); // Use Math.ceil to round up to the nearest whole number of days
            };
    
            const curloans = loansResponse.data.current.loans;
            const curtotals = loansResponse.data.current.totals;
            const pastloans = loansResponse.data.pastDue.loans;
            const pasttotals = loansResponse.data.pastDue.totals;
            
            if (curloans.length > 0) {
                
                const tableRows = curloans.map(item => {
                    
                    const dates = calculateDueDates(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate);
                    const paymentsArr = calculatePayments(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate, item.payments);
                    const lastDueDate = dates[dates.length - 1].date;
    
                    return [
                        `${item.applicant.lastName}, ${item.applicant.firstName} ${item.applicant.middleName}`,
                        item.id.toString().padStart(6, '0'),
                        `${format(item.dateGranted, 'MM/dd/yyyy')} - ${lastDueDate}`,
                        parseFloat(item.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parseFloat(((item.amountGranted * (item.interestRate/100)) * item.loanTerm)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parseFloat(paymentsArr.remainingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        `${item.interestRate}%`,
                        countDaysBetweenDates(item.dateGranted, lastDueDate),
                        item.loanLedger,
                        item.loanProduct,
                        item.accountOfficer,
                        item.loanType
                    ];
                });

                const currentheader = [
                    'CURRENT','','','','','','','','','','',''
                ];

                tableRows.unshift(currentheader);

                const currenttotals = [
                    'Number of Accounts:',
                    curtotals.count,
                    '',
                    parseFloat(curtotals.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    parseFloat(curtotals.interest).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    parseFloat(curtotals.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    ,'','','','','',''
                ];

                tableRows.push(currenttotals);


                doc.autoTable({
                    head: [tableColumn],
                    body: tableRows,
                    startY: currentY,
                    didParseCell: function (data) {
                        const rowIndex = data.row.index;
                        if (rowIndex === 0) {
                            data.cell.styles.fontStyle = 'bold';
                        }
                    }
                });

                currentY = doc.lastAutoTable.finalY + 20; // Update currentY to be below the last table
            }


            if (pastloans.length > 0) {
                
                const tableRows = pastloans.map(item => {
                    
                    const dates = calculateDueDates(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate);
                    const paymentsArr = calculatePayments(item.dateGranted, item.loanInterval, item.loanTerm, item.amountGranted, item.interestRate, item.payments);
                    const lastDueDate = dates[dates.length - 1].date;
    
                    return [
                        `${item.applicant.lastName}, ${item.applicant.firstName} ${item.applicant.middleName}`,
                        item.id.toString().padStart(6, '0'),
                        `${format(item.dateGranted, 'MM/dd/yyyy')} - ${lastDueDate}`,
                        parseFloat(item.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parseFloat(((item.amountGranted * (item.interestRate/100)) * item.loanTerm)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        parseFloat(paymentsArr.remainingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        `${item.interestRate}%`,
                        countDaysBetweenDates(item.dateGranted, lastDueDate),
                        item.loanLedger,
                        item.loanProduct,
                        item.accountOfficer,
                        item.loanType
                    ];
                });

                const pastheader = [
                    'PASTDUE','','','','','','','','','','',''
                ];

                tableRows.unshift(pastheader);

                const pastduetotals = [
                    'Number of Accounts:',
                    pasttotals.count,
                    '',
                    parseFloat(pasttotals.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    parseFloat(pasttotals.interest).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    parseFloat(pasttotals.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    ,'','','','','',''
                ];

                tableRows.push(pastduetotals);

                doc.autoTable({
                    head: [tableColumn],
                    body: tableRows,
                    startY: currentY,
                    didParseCell: function (data) {
                        const rowIndex = data.row.index;
                        if (rowIndex === 0) {
                            data.cell.styles.fontStyle = 'bold';
                        }
                    }
                });
            }
    
            const now = new Date();
            const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            doc.save(`Loan_Listing_By_Loan_Status_${timestamp}.pdf`);
            setShowSpinner(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
            setShowSpinner(false);
        }
    };       

    const handleClick = (e) => {
        e.preventDefault();
        handleGeneratePDF();
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <div className="filters-container">
                <div className="date-range-controls">
                    <label htmlFor="endDate">As of: </label>
                    <input
                        type="date"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <Button href="#" onClick={handleClick} className="generate-pdf-button">
                    <i className="fa-solid fa-print"></i> Export
                </Button>
            </div>
            {loanCurrent && (
                <>
                    <h3 className="table-heading">Current</h3>
                    <Table className="list-container" hover responsive>
                        <thead className="list-title">
                            <tr>
                                {paymentHeaders.map((item, index) => (
                                    <th className="list-header-item" key={index}>{item.value}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.values(loanCurrent).map((item, index) => (
                                <tr className="list-body" key={index}>
                                    {item.items.map((subitem, subindex) => (
                                        <td className="list-body-item" key={`${index}+${subindex}`}>
                                            {subitem.value}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            <tr className="list-body">
                                <td className="list-body-item">Number of Accounts:</td>
                                <td className="list-body-item">{loanCurrentTotals.count}</td>
                                <td className="list-body-item">&nbsp;</td>
                                <td className="list-body-item"><ToPeso amount={loanCurrentTotals.amountGranted} /></td>
                                <td className="list-body-item"><ToPeso amount={loanCurrentTotals.interest} /></td>
                                <td className="list-body-item"><ToPeso amount={loanCurrentTotals.balance} /></td>
                                <td className="list-body-item" colSpan={6}>&nbsp;</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr className="page-buttons">
                                <td colSpan="12">
                                    &nbsp;
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </>
            )}

            {loanPastdue && (
                <>
                    <h3 className="table-heading">Past Due</h3>
                    <Table className="list-container" hover responsive>
                        <thead className="list-title">
                            <tr>
                                {paymentHeaders.map((item, index) => (
                                    <th className="list-header-item" key={index}>{item.value}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.values(loanPastdue).map((item, index) => (
                                <tr className="list-body" key={index}>
                                    {item.items.map((subitem, subindex) => (
                                        <td className="list-body-item" key={`${index}+${subindex}`}>
                                            {subitem.value}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            <tr className="list-body">
                                <td className="list-body-item">Number of Accounts:</td>
                                <td className="list-body-item">{loanPastdueTotals.count}</td>
                                <td className="list-body-item">&nbsp;</td>
                                <td className="list-body-item"><ToPeso amount={loanPastdueTotals.amountGranted} /></td>
                                <td className="list-body-item"><ToPeso amount={loanPastdueTotals.interest} /></td>
                                <td className="list-body-item"><ToPeso amount={loanPastdueTotals.balance} /></td>
                                <td className="list-body-item" colSpan={6}>&nbsp;</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr className="page-buttons">
                                <td colSpan="12">
                                    &nbsp;
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </>
            )}

        </>
    );
}

export default ReportLoanListingByLoanStatus;
